import { useCallback, useEffect, useState } from 'react';

import { Pylon } from '@/lib/Pylon';

export const usePylonChat = () => {
  const [showPylonChat, setShowPylonChat] = useState(false);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  Pylon.useShowEffect(showPylonChat, setShowPylonChat);

  useEffect(() => {
    window.Pylon?.('onChangeUnreadMessagesCount', (count: number) => {
      setUnreadMessageCount(count);
    });
  }, []);

  useEffect(() => {
    if (!showPylonChat) {
      return;
    }

    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const pylonChat = document.getElementById('pylon-chat');
      if (pylonChat && !pylonChat.contains(event.target as Node)) {
        setShowPylonChat(false);
      }
    };

    const timeoutId = setTimeout(() => {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showPylonChat]);

  const toggleChat = useCallback(() => {
    setShowPylonChat((prev) => !prev);
  }, []);

  return {
    showPylonChat,
    setShowPylonChat,
    unreadMessageCount,
    toggleChat
  };
};
